export enum KeycloakCatsUserRoles {
  Maintainer = 'trial-maintainer',
  Reporter = 'trial-reporter',
  Viewer = 'trial-viewer',
  Patient = 'trial-patient',
}
